import LinkPanel from './LinkPanel';

export default LinkPanel;